export enum MentionTypes {
	HASHTAG = "HASHTAG",
	CONNECTION = "CONNECTION"
}
